/**
 *  内部版本 的 { type: 'JSExpression', source: '', value: '', extType: 'function' } 能力上等同于 JSFunction
 */
export function isInnerJsFunction(data) {
  return data && data.type === 'JSExpression' && data.extType === 'function';
}
export function isJSFunction(data) {
  return typeof data === 'object' && data && data.type === 'JSFunction' || isInnerJsFunction(data);
}